import React from "react";
import BreadCrumb from "../../../../layout/BreadCrumb";
import Header from "./Header";
import OverviewStepList from "./overview-tab/OverviewStepList";

function PlannedViewList() {
  return (
    <div>
      <BreadCrumb
        breadcrumbs={[
          { title: "Planned Projects", path: "/planned-pipeline" },
          { title: "Overview" },
        ]}
      />

      <div className="white_card mt-[1.25rem]">
        <Header />
        <OverviewStepList />
      </div>
    </div>
  );
}

export default PlannedViewList;
